import React, { useState, useEffect } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { Modal } from 'rsuite'
import { Table, Checkbox } from 'rsuite'
import { getAllSuppliersData, getListSuppliers, matchListSupplierToSupplier, createChildForListSupplier } from '../../../redux/actions/vendor'
import { createAutoMastersForListSuppliers, getAllRemainingListSuppliersIds, autoCreateMasterChildSupplierWorker } from '../../../redux/actions/caller'
import { getAllRemainingPartnerSubmissionIds, createAutoMastersForPartnerSubmissions } from '../../../redux/actions/partnerSubmissions'
import CheckboxComponent from '../../CommonComponents/CheckboxComponent'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import { toast } from '../../CommonComponents/ToastComponent/toast'
import CreateMasterModal from '../../AssignVendorComponent/modals/create-master'
import ModalComponent from '../../CommonComponents/Modal'
import { checkIsAdminOrModerator } from '../../../services/helper'
import { approvePartnerSubmissionAfterRerun, getPartnerSubmissions } from '../../../redux/actions/partnerSubmissions'
const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, ...props }) => {
    if (dataKey === 'isAcceptCardAcceptance') {
        if (rowData?.cardAcceptance?.isAcceptAmericanExpress === true || rowData?.cardAcceptance?.isAcceptVisa === true || rowData?.cardAcceptance?.isAcceptMasterCard === true) {
            rowData[dataKey] = 'Yes'
        } else if (rowData?.cardAcceptance?.isAcceptAmericanExpress === null && rowData?.cardAcceptance?.isAcceptVisa === null && rowData?.cardAcceptance?.isAcceptMasterCard === null) {
            rowData[dataKey] = 'Unknown'
        } else if (rowData?.cardAcceptance?.isAcceptAmericanExpress === false && rowData?.cardAcceptance?.isAcceptVisa === false && rowData?.cardAcceptance?.isAcceptMasterCard === false) {
            rowData[dataKey] = 'No'
        }
    } else {
        rowData[dataKey] = rowData?.payment?.[dataKey] === null ? 'Unknown' : rowData?.payment?.[dataKey] === false ? 'No' : 'Yes'
    }
    return (
        <Cell {...props} className="table-link">
            {rowData[dataKey]}
        </Cell>
    )
}
const CreateMastersModal = ({ show, handleClose, columns, listId = null, onCreateMaster, generalInfoData = {}, isPartnerSubmission = false, onPage = 'list' }) => {
    const dispatch = useDispatch()
    const store = useStore().getState()
    const {
        domain: {
            currentDomain,
        }
    } = store
    const isAdminOrMod = checkIsAdminOrModerator(currentDomain)
    const [checked, setChecked] = useState(false)
    const [indeterminate, setIndeterminate] = useState(false)
    const [checkedKeys, setCheckedKeys] = useState([])
    const [checkedSuppliers, setCheckedSuppliers] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [tableData, setTableData] = useState([])
    const [totalData, setTotalData] = useState(0)
    const [sortColumn, setSortColumn] = useState('suppliername');
    const [sortType, setSortType] = useState('asc');
    const [isLoadingTableData, setIsLoadingTableData] = useState(false)
    const [selectAllRemaining, setSelectAllRemaining] = useState(false)
    const [remainingCheckedKeys, setRemainingCheckedKeys] = useState([])
    const [showCreateBulkMastersModal, setShowCreateBulkMastersModal] = useState(false)
    const [isGetUnmatchedData, setIsGetUnmatchedData] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isAutoCreateMaster, setIsAutoCreateMaster] = useState(false)
    const [showAutoCreateMastersModal, setShowAutoCreateMastersModal] = useState(false)
    const [contactsData, setContactsData] = useState([])

    useEffect(() => {
        getTableData(10, 1, sortColumn, sortType)
    }, [])

    useEffect(() => {
        if (!checkedKeys || !checkedKeys?.length) {
            setSelectAllRemaining(false)
            return
        }
        if (checkedKeys?.length < totalData) {
            setSelectAllRemaining(false)
        } else if (checkedKeys?.length === totalData) {
            setSelectAllRemaining(true)
        }
    }, [checkedKeys])

    const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, disabled, ...props }) => (
        <Cell {...props} style={{ padding: 0 }}>
            <Checkbox
                value={rowData[dataKey]}
                onChange={onChange}
                checked={checkedKeys.some(item => item === rowData[dataKey])}
                disabled={disabled}
            />
        </Cell>
    )

    const handleCheckAll = (value, checked) => {
        let keys = checked ? tableData.map(item => item.id) : []
        setCheckedKeys(keys)
        setIndeterminate(false)
        setChecked(checked)
        if (checked) {
            setCheckedSuppliers(tableData)
        } else {
            setCheckedSuppliers([])
        }
    }

    const handleCheck = (value, checked) => {
        const nextCheckedKeys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value)
        let tmpCheckedSuppliers = [...checkedSuppliers];
        setCheckedKeys(nextCheckedKeys)
        if (checked) {
            tmpCheckedSuppliers = [...tmpCheckedSuppliers, tableData.find(row => row.id === value)]
        } else {
            tmpCheckedSuppliers = tmpCheckedSuppliers.filter(row => row.id !== value)
        }
        const isAllChecked = tableData.filter(item => nextCheckedKeys.includes(item.id))
        setIndeterminate((!isAllChecked?.length || isAllChecked?.length === tableData?.length) ? false : true)
        setChecked(isAllChecked?.length === tableData?.length ? true : false)
        setCheckedSuppliers(tmpCheckedSuppliers)
    }

    const handleChangeLimit = async (dataKey) => {
        await getTableData(dataKey, 1, sortColumn, sortType)
        setPage(1);
        setLimit(dataKey);
    }

    const handleChangePage = async (page) => {
        await getTableData(limit, page, sortColumn, sortType)
        setPage(page);
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
        getTableData(limit, page, sortColumn, sortType)
    };

    const getTableData = async (limit, page, sortColumn, sortType) => {
        setIsLoadingTableData(true)
        try {
            if (!isPartnerSubmission && listId) {
                const res = await dispatch(getListSuppliers({
                    listId: listId,
                    type: 'unmatched',
                    limit: limit,
                    offset: limit * (page - 1),
                    sortColumn: sortColumn,
                    sortType: sortType,
                    isGetAcceptanceInfo: true,
                    fromCreateMasterModal: true
                }))

                setTotalData(res?.totalListSuppliers || 0)
                setTableData(res?.listSuppliers || [])
                const isAllChecked = res?.listSuppliers?.filter(item => checkedKeys.includes(item.id))
                setIndeterminate((!isAllChecked?.length || isAllChecked?.length === res?.listSuppliers?.length) ? false : true)
                setChecked(isAllChecked?.length === res?.listSuppliers?.length ? true : false)
                setContactsData(res?.contacts || [])
            } else if (!listId && isPartnerSubmission) {
                const res = await dispatch(getPartnerSubmissions({
                    type: 'unmatched',
                    sortColumn: sortColumn,
                    sortType: sortType,
                    limit: limit,
                    offset: limit * (page - 1),
                    isGetAcceptanceInfo: true
                }))

                setTableData(res?.partnerSubmissions || [])
                setTotalData(res?.total || 0)
            }
        } catch (error) {
            setTableData([])
            setTotalData(0)
        } finally {
            setIsLoadingTableData(false)
        }
    }

    const headerElements = columns.map((col, index) => {
        if (index === 5 || index === 6 || index === 7) {
            return (
                <Column
                    resizable
                    key={col.name}
                >
                    <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                    <LinkCell dataKey={col.name} />
                </Column>
            )
        }
        return (
            <Column
                resizable
                sortable={(index === 0 || index === 1 || index === 2 || index === 3) ? true : false}
                key={col.name}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <Cell className='text-black' dataKey={col.name} />
            </Column>
        )
    })

    const onSelectAllRemaining = async (checked) => {
        setIsLoadingTableData(true)
        let keys = [...checkedKeys]
        if (checked) {
            if (onPage == 'partnerSubmissions') {
                await dispatch(getAllRemainingPartnerSubmissionIds({ checkedIds: keys })).then(async (partnerSubmissionsIds) => {
                    await partnerSubmissionsIds.map(item => keys.push(item.id))
                    setIsLoadingTableData(false)
                    const isAllChecked = tableData.filter(item => keys.includes(item.id))
                    setIndeterminate((!isAllChecked?.length || isAllChecked?.length === tableData?.length) ? false : true)
                    setChecked(isAllChecked?.length === tableData?.length ? true : false)
                    setCheckedSuppliers(partnerSubmissionsIds)
                }).catch(() => {
                    setIsLoadingTableData(false)
                })
            } else {
                await dispatch(getAllRemainingListSuppliersIds({ listId, checkedKeys: keys, isGetUnmatched: true, isGetAcceptanceInfo: false, fromAutoCreateMasterModal: true })).then(async (listSupplierIds) => {
                    await listSupplierIds.map(item => keys.push(item.id))
                    setRemainingCheckedKeys(listSupplierIds)
                    setIsLoadingTableData(false)
                    const isAllChecked = tableData.filter(item => keys.includes(item.id))
                    setIndeterminate((!isAllChecked?.length || isAllChecked?.length === tableData?.length) ? false : true)
                    setChecked(isAllChecked?.length === tableData?.length ? true : false)
                    const tmpCheckedSupplier = [...checkedSuppliers, ...listSupplierIds]
                    setCheckedSuppliers(tmpCheckedSupplier)
                }).catch(() => {
                    setIsLoadingTableData(false)
                })
            }
        } else {
            keys = []
            setChecked(false)
            setCheckedSuppliers([])
            if (keys?.length) {
                setIndeterminate(true)
            } else {
                setIndeterminate(false)
            }
            setRemainingCheckedKeys([])
            setIsLoadingTableData(false)
        }

        setCheckedKeys(keys)
        setSelectAllRemaining(checked)
    }

    const handleCreateMaster = () => {
        if (!checkedKeys || !checkedKeys.length) {
            toast.show({
                title: 'Warning',
                description: 'No data is selected!',
            })
            return
        }
        if (isAutoCreateMaster) {
            setShowAutoCreateMastersModal(true)
        } else {
            setShowCreateBulkMastersModal(true)
        }
    }

    const handleAutoCreateMasters = async () => {
        setIsLoading(true)
        try {
            if (!listId && isPartnerSubmission) {
                for (let i = 0; i < checkedSuppliers?.length; i++) {
                    delete checkedSuppliers?.[i]?.cardAcceptance?.listSupplierId;
                    delete checkedSuppliers?.[i]?.payment?.listSupplierId;
                    await dispatch(createAutoMastersForPartnerSubmissions({
                        partnerSubmission: checkedSuppliers[i]
                    }));
                }
            } else {
                const checkedSuppliersIds = [];
                for (let i = 0; i < checkedSuppliers?.length; i++) {
                    checkedSuppliersIds.push(checkedSuppliers[i]?.id);
                }

                const BATCH_SIZE = 50000;
                for (let i = 0; i < checkedSuppliersIds?.length; i += BATCH_SIZE) {
                    const batch = checkedSuppliersIds?.slice(i, i + BATCH_SIZE);
                    if (batch && batch?.length > 0) {
                        await dispatch(autoCreateMasterChildSupplierWorker({
                            listSupplierIds: batch,
                            domainId: generalInfoData?.domainId,
                            listUploadUserId: generalInfoData?.userId,
                            listId: listId
                        }))
                    }
                }
            }
            await getTableData(limit, 1, sortColumn, sortType);
            setChecked(false);
            setIndeterminate(false);
            setCheckedKeys([]);
            setCheckedSuppliers([]);
            onCreateMaster(true);
            setShowAutoCreateMastersModal(false);
            setIsAutoCreateMaster(false);
            if (selectAllRemaining && isAutoCreateMaster) {
                handleClose(true)
            }
        } catch (error) {
            toast.show({
                title: 'Error',
                description: 'Failed to create masters'
            });
        } finally {
            setIsLoading(false)
        }
    }

    const handleConfirmClick = async (id, matchedSupplierId, status, listId = null) => {
        setIsLoading(true)
        if (!id) {
            toast.show({
                title: 'Warning',
                description: 'No Matched Supplier Id Found!'
            })
            return
        }

        dispatch(!listId && isPartnerSubmission ?
            approvePartnerSubmissionAfterRerun(id, { id: matchedSupplierId, matchScore: null }, matchedSupplierId, status ? status : 'Manually Matched Master')
            :
            matchListSupplierToSupplier({
                id,
                matchedSupplierId,
                status: status ? status : 'Manually Matched Master'
            })).then(async () => {
                setIsLoading(false)
                setIsGetUnmatchedData(true)
                toast.show({
                    title: 'Success',
                    description: 'Successfully matched list supplier!'
                })
                var currentIndex = checkedKeys?.indexOf(id);
                const nextIndex = (currentIndex + 1) % checkedKeys?.length;
                if (!nextIndex) {
                    await getTableData(limit, 1, sortColumn, sortType)
                    setChecked(false)
                    setIndeterminate(false)
                    setCheckedKeys([])
                    setCheckedSuppliers([])
                    setShowCreateBulkMastersModal(false)
                    onCreateMaster(true)
                }
            }).catch(() => {
                setIsLoading(false)
                setShowCreateBulkMastersModal(false)
                toast.show({
                    title: 'Error',
                    description: 'Failed to match list supplier!'
                })
            })

        if (listId && !isPartnerSubmission) {
            let { domainId, userId } = generalInfoData
            dispatch(createChildForListSupplier(
                id,
                matchedSupplierId,
                domainId,
                userId,
                listId,
                matchedSupplierId
            )).then(() => {
                toast.show({
                    title: 'Success',
                    description: 'Child supplier created successfully!'
                })
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create child supplier!'
                })
            })
        }
    }

    return (
        <>
            <Modal
                backdrop='static'
                className="send-call-modal"
                show={show}
                size="lg"
                onClick={() => { handleClose(isGetUnmatchedData); setIsGetUnmatchedData(false) }}
                onHide={() => { handleClose(isGetUnmatchedData); setIsGetUnmatchedData(false) }}
            >
                <Modal.Header>
                </Modal.Header>
                <Modal.Body className={`${isLoadingTableData ? 'position-relative loading' : ''}`}>
                    {isLoadingTableData && <LoaderComponent />}
                    <div className='call-vendor-list'>
                        <div className='header d-flex mb-3 align-items-center'>
                            <h3 className='mb-0 fw-bold text-black'>Create Masters</h3>
                            <div className='d-flex gap-3 align-items-center select-options-parent flex-grow-1'>
                                {isAdminOrMod && (
                                    <div className='ms-auto me-3'>
                                        <CheckboxComponent
                                            label={`Auto Create Master`}
                                            onChange={(checked) => { setIsAutoCreateMaster(checked) }}
                                            checked={isAutoCreateMaster}
                                            disabled={isLoadingTableData || tableData?.length === 0}
                                        />
                                    </div>
                                )}
                                <div className={`${isAdminOrMod ? '' : 'ms-auto'}`}>
                                    <CheckboxComponent
                                        label={`${selectAllRemaining ? 'Unselect All' : 'Select All Remaining'}`}
                                        onChange={(checked) => { onSelectAllRemaining(checked) }}
                                        checked={selectAllRemaining}
                                        disabled={isLoadingTableData || tableData?.length === 0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='border border-2'>
                            <Table
                                virtualized
                                affixHeader={true}
                                data={tableData}
                                height={500}
                                minHeight={200}
                                sortColumn={sortColumn}
                                sortType={sortType}
                                onSortColumn={handleSortColumn}
                            >
                                <Column width={50} align="center">
                                    <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Checkbox
                                            checked={checked}
                                            indeterminate={indeterminate}
                                            onChange={handleCheckAll}
                                        />
                                    </HeaderCell>
                                    <CheckCell
                                        dataKey="id"
                                        checkedKeys={checkedKeys}
                                        onChange={handleCheck}
                                    />
                                </Column>
                                {headerElements}
                            </Table>
                            <div className="full-vendor-table-pagination">
                                <Pagination
                                    prev
                                    next
                                    first={true}
                                    last={true}
                                    maxButtons={5}
                                    activePage={page}
                                    showInfo
                                    displayLength={limit}
                                    lengthMenu={[
                                        {
                                            label: '10',
                                            value: 10,
                                        },
                                        {
                                            label: '20',
                                            value: 20,
                                        },
                                        {
                                            label: '30',
                                            value: 30,
                                        },
                                        {
                                            label: '50',
                                            value: 50,
                                        },
                                        {
                                            label: '100',
                                            value: 100,
                                        },
                                    ]}
                                    total={totalData}
                                    onChangeLength={handleChangeLimit}
                                    onChangePage={(event) => { handleChangePage(event) }}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='rounded h4 mb-0 text-white bg-green pt-3 pb-3 p-5' onClick={() => { handleCreateMaster() }} disabled={isLoadingTableData || tableData?.length === 0}>Confirm</button>
                </Modal.Footer>
            </Modal>
            {showCreateBulkMastersModal && (
                <Modal
                    backdrop='static'
                    className="create-supplier-modal m-5 p-5"
                    show={showCreateBulkMastersModal}
                    size="xl"
                    onClick={() => { setShowCreateBulkMastersModal(false) }}
                    onHide={() => { setShowCreateBulkMastersModal(false) }}>
                    <Modal.Header></Modal.Header>
                    <Modal.Body>
                        <CreateMasterModal
                            isFromList={true}
                            onClose={() => { setShowCreateBulkMastersModal(false); setCheckedKeys([]); setCheckedSuppliers([]) }}
                            onUpdateListSupplier={handleConfirmClick}
                            isCreatingMasterFromList={isLoading}
                            selectedKeys={checkedKeys}
                            isCreateNewLocationMaster={false}
                            selectedChildSuppliers={checkedSuppliers}
                            isCreatingMasters={true}
                            generalInfoData={generalInfoData}
                            contactsData={contactsData}
                        />
                    </Modal.Body>
                </Modal>
            )}
            {showAutoCreateMastersModal && (
                <ModalComponent
                    backdrop={'static'}
                    open={showAutoCreateMastersModal}
                    handleClose={() => { !isLoading && setShowAutoCreateMastersModal(false) }}
                    modalTitle={'Auto Create Master'}
                    size={`md`}
                    isLoading={isLoading}
                >
                    <h4 className='mb-0 text-black fw-bold m-auto'>
                        <p className='text-center'>Are you sure you want to Auto Create Master for all selected List Suppliers?</p>
                    </h4>
                    <div className='mt-4'>
                        <button
                            className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white width-100'
                            disabled={isLoading}
                            onClick={() => { !isLoading && setShowAutoCreateMastersModal(false) }}>
                            Cancel
                        </button>
                        <button
                            className='pt-2 pb-2 h4 mb-0 fw-bold rounded btn-green text-white ms-auto width-100'
                            disabled={isLoading}
                            onClick={() => { handleAutoCreateMasters() }}
                        >
                            Ok
                        </button>
                    </div>
                </ModalComponent>
            )}
        </>
    )
}

export default CreateMastersModal